import { createWsConnectThunks, WsPrefixes } from '@skynet/data-ws-core';
import type { WsEsState } from './slice';

export type EsWsState = { wsEs: WsEsState };

const { wsLogout, wsDisconnect, subscribeWsData } = createWsConnectThunks({
  sliceKey: 'wsEs',
  prefix: WsPrefixes.esPrefix,
  logoutCommand: 'Logout',
  disconnectCommand: 'Disconnect',
});

export {
  wsLogout as wsEsLogout,
  wsDisconnect as wsEsDisconnect,
  subscribeWsData as subscribeWsEsData,
};
